import * as React from 'react';
import { MergeSubscriberGroupButtonProps } from 'app/area/subscriber-groups/shared/merge-subscriber-group/types';

export const MergeSubscriberGroupButton = (props: MergeSubscriberGroupButtonProps) => {
  const { id, name, mergeSubscriberGroup, translation, updateMergeSubscriberGroup } = props;

  const handleMergeCodeItem = () => {
    updateMergeSubscriberGroup({
      id, name, fetching: mergeSubscriberGroup?.fetching,
      showMergeSubscriberGroup: !mergeSubscriberGroup?.showMergeSubscriberGroup
    });
  };

  return <button
    type="button"
    className="dropdown-item"
    onClick={handleMergeCodeItem}>
    {translation.delete}
  </button>;
};
